// Operational Intelligence: the routes and the sidebar rows of `wealth.intelligence.operational` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.intelligence.operational',
    routes: [
        {
            frontend: 'view',
            path: 'operational-intelligence',
            lazy: () => import('@/pages/view/operational-intelligence/page'),
        },
        {
            frontend: 'view',
            path: 'operational-intelligence/detail',
            lazy: () => import('@/pages/view/operational-intelligence/detail/page'),
        },
    ],
    nav: [
        {
            frontend: 'view',
            key: 'operational-intelligence',
            label: 'Operational Intelligence',
            href: '/view/operational-intelligence',
            icon: 'Activity',
            group: 'intelligence',
            order: 310,
        },
    ],
});
